import React from 'react';
import styled from 'styled-components';

const Container  = styled.div`
    padding: 5rem;
`;

const BE = props => {

  return (
    <Container>
      <h3>Dev - Be channel</h3>
    </Container>
  );
};

BE.propTypes = {};

export default BE;
